<div class="activities-container">
  <!-- Header -->
  <div class="activities-header">
    <div class="header-content">
      <h3><i class="fas fa-history"></i> Activity Timeline</h3>
      <div class="header-stats">
        <div class="stat-item">
          <span class="stat-label">Total Activities</span>
          <span class="stat-value">{{ activities.length }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">This Month</span>
          <span class="stat-value">{{ getThisMonthCount() }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Follow-ups Due</span>
          <span class="stat-value">{{ getFollowUpCount() }}</span>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" (click)="showCreateForm = !showCreateForm">
      <i class="fas fa-plus"></i> {{ showCreateForm ? 'Cancel' : 'Log Activity' }}
    </button>
  </div>

  <!-- Create Activity Form -->
  <div class="create-form" *ngIf="showCreateForm">
    <div class="form-header">
      <h4><i class="fas fa-plus-circle"></i> Log New Activity</h4>
    </div>
    <div class="form-content">
      <div class="form-row">
        <div class="form-group">
          <label for="type">Activity Type</label>
          <select id="type" [(ngModel)]="newActivity.type_id" class="form-select">
            <option value="0">Select Activity Type</option>
            <option *ngFor="let type of activityTypes" [value]="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="activityDate">Activity Date</label>
          <input type="datetime-local" id="activityDate" [(ngModel)]="newActivity.activity_date" class="form-input">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label for="followUpDate">Follow-up Date</label>
          <input type="datetime-local" id="followUpDate" [(ngModel)]="newActivity.follow_up_date" class="form-input">
        </div>
        <div class="form-group">
          <label for="outcome">Outcome</label>
          <input type="text" id="outcome" [(ngModel)]="newActivity.outcome" class="form-input" placeholder="Activity outcome">
        </div>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea id="description" [(ngModel)]="newActivity.description" class="form-textarea" rows="3" placeholder="Describe the activity"></textarea>
      </div>
      <div class="form-actions">
        <button class="btn btn-secondary" (click)="showCreateForm = false; resetForm()">
          <i class="fas fa-times"></i> Cancel
        </button>
        <button class="btn btn-success" (click)="createActivity()" [disabled]="!newActivity.type_id || !newActivity.description">
          <i class="fas fa-save"></i> Log Activity
        </button>
      </div>
    </div>
  </div>

  <!-- Activities Timeline -->
  <div class="timeline-container" *ngIf="!loading">
    <div class="timeline" *ngIf="activities.length > 0">
      <div class="timeline-item" *ngFor="let activity of activities; let i = index">
        <div class="timeline-marker" [style.background-color]="getActivityTypeColor(activity.type_id)">
          <i [class]="getActivityTypeIcon(activity.type_id)"></i>
        </div>
        <div class="timeline-content">
          <div class="activity-card">
            <div class="card-header">
              <div class="activity-info">
                <h4>{{ getActivityTypeName(activity.type_id) }}</h4>
                <div class="activity-meta">
                  <span class="activity-date">
                    <i class="fas fa-calendar"></i>
                    {{ formatDate(activity.activity_date || activity.created_at || '') }}
                  </span>
                  <span class="relative-time">{{ getRelativeTime(activity.activity_date || activity.created_at || '') }}</span>
                </div>
              </div>
              <div class="card-actions">
                <button class="btn-icon" (click)="editingActivity = activity" title="Edit">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="btn-icon" (click)="deleteActivity(activity)" title="Delete">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>

            <div class="card-content">
              <div class="activity-description">
                <p>{{ activity.description }}</p>
              </div>

              <div class="activity-details" *ngIf="activity.outcome || activity.follow_up_date">
                <div class="detail-item" *ngIf="activity.outcome">
                  <label>Outcome:</label>
                  <span>{{ activity.outcome }}</span>
                </div>
                <div class="detail-item" *ngIf="activity.follow_up_date">
                  <label>Follow-up:</label>
                  <span class="follow-up-date">
                    <i class="fas fa-clock"></i>
                    {{ formatDate(activity.follow_up_date) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="activities.length === 0">
      <div class="empty-icon">
        <i class="fas fa-history"></i>
      </div>
      <h4>No Activities Yet</h4>
      <p>Start tracking customer interactions and activities.</p>
      <button class="btn btn-primary" (click)="showCreateForm = true">
        <i class="fas fa-plus"></i> Log First Activity
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading activities...</p>
  </div>
</div>









